import { ReactComponent as DownloadIcon } from "../../assets/img/download.svg";
import { educator } from "../../assets/text/educator";

const EducatorKitMobileScreen = () => {
  return (
    <div className="educator-mobilescreen-english">
      <div className="educator-mobilescreen-english-container">
        {educator.english.text.map((text, textIndex) => {
          let parts = text.split(/\*\*/g);
          return (
            <div style={{ marginBottom: "5%" }}>
              {parts.map((part, partIndex) => {
                if (partIndex % 2 === 0 && part) {
                  return (
                    <span
                      className="educator-mobilescreen-english-text"
                      key={partIndex}
                    >
                      {part}
                    </span>
                  );
                } else if (part) {
                  return (
                    <span
                      className="educator-mobilescreen-english-text-heading"
                      key={partIndex}
                    >
                      {part}
                    </span>
                  );
                }
              })}
            </div>
          );
        })}
        <a
          href="pdf/educator_english.pdf"
          download
          className="educator-mobilescreen-english-download"
        >
          download pdf
          <DownloadIcon style={{ marginLeft: "3%" }} />
        </a>
      </div>
    </div>
  );
};

export default EducatorKitMobileScreen;
